import styled from 'styled-components';
import { InputDescription } from '@awaze/design-system.components.input';
export const StyledInputDescription = styled(InputDescription) `
  color: ${({ theme }) => theme.ColorGrey700};
`;
//# sourceMappingURL=input-group.styles.js.map